<template>
  <w-setting-sliding-popup ref="slidingPopup"  title="정책 수정" width="400px" @close="close">
    <div slot="content">
      <el-form ref="ruleForm" :rules="rules" :model="modifiedData">
        <el-row>
          <el-form-item prop="ruleTmplId" label="정책 아이디">
            <el-input :disabled="true" v-model="modifiedData.ruleTmplId"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="ruleTmplName" label="정책명">
            <el-input v-model="modifiedData.ruleTmplName"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="ruleTmplDesc" label="설명">
            <el-input type="textarea" :rows="7" v-model="modifiedData.ruleTmplDesc"/>
          </el-form-item>
        </el-row>
      </el-form>
      <!-- <span v-show="isDefaultRule">기본 정책은 수정할 수 없습니다.</span> -->
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="saveRule">저장</el-button>
      <el-button size="large" @click="onCancelButtonClick">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import { isTrue } from '@/utils/boolean';
import msgUtil from '@/utils/message';
import RuleSettingAPI from '@/api/settings/common/rule-settings';

export default {
  name: 'WModifyRulePopup',
  props: {
    ruleType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modifiedData: { // 정책 정보
        ruleTmplId: '',
        ruleTmplName: '',
        ruleTmplDesc: '',
      },
      rules: { // 정책 폼 rules
        ruleTmplId: [{ required: true, trigger: 'blur', message: '정책 아이디를 입력해주십시오.' }],
        ruleTmplName: [{ required: true, trigger: 'blur', message: '정책명을 입력해주십시오.' }],
      },
      ruleList: [], // 복사할 정책 목록
    };
  },
  computed: {
    isDefaultRule() {
      return isTrue(this.modifiedData.defaultFlag);
    },
  },
  methods: {
    /**
     * 정책 수정 팝업을 연다.
     * @author Ju
     */
    open(rule) {
      this.$refs.slidingPopup.open();
      // if (this.ruleType !== ruleType.RSC) {
      //   const ruleTmplId = rule.ruleTmplId;
      //   rule.ruleTmplId = ruleTmplId.substring(ruleTmplId.indexOf('_') + 1);
      // }
      this.modifiedData = rule;
    },
    /**
     * 정책 수정 팝업 닫기 이벤트 핸들러
     * @author Ju
     */
    close() {
      this.modifiedData = {
        ruleTmplId: '',
        ruleTmplName: '',
        ruleTmplDesc: '',
      };
      this.$refs.ruleForm.clearValidate();
    },
    /**
     * 취소 버튼 이벤트 핸들러
     * @author Ju
     */
    onCancelButtonClick() {
      this.$refs.slidingPopup.close();
    },
    /**
   * 정책을 수정한다.
   * @return {[type]} [description]
   * @author jda
   */
    saveRule() {
      const params = Object.assign(this.modifiedData, { ruleType: this.ruleType });
      RuleSettingAPI.updateRule(params)
        .then((response) => {
          if (response.data.success) {
            this.onCancelButtonClick();
            this.$emit('close');
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '정책', response.data.success));
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/popup/ModifyRulePopup.vue